(function () {
  'use strict';

  var overlay = document.getElementById('regada-intro');
  if (!overlay) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Timing (ms) ──────────────────────────────────────────
  // logo fade-in:  400ms  (CSS: 0.4s, delay 0.1s → finishes at ~500ms)
  // hold:          250ms  (logo visible before wipe starts)
  // overlay wipe:  400ms  (CSS: 0.4s)
  // total:         ~950ms

  var HOLD_DURATION = 550;  // when to start the wipe (after logo is fully in)
  var WIPE_DURATION = 420;  // matches CSS animation duration + small buffer
  var REDUCED_TOTAL = 400;  // flat fade time for reduced-motion

  function runIntro(onComplete) {
    overlay.classList.remove('is-done', 'is-leaving');
    // Force reflow so re-triggering the animation works on repeat visits
    void overlay.offsetWidth;

    overlay.classList.add('is-animating');

    var holdTimer = setTimeout(function () {
      overlay.classList.add('is-leaving');

      var doneTimer = setTimeout(function () {
        overlay.classList.add('is-done');
        if (typeof onComplete === 'function') onComplete();
      }, WIPE_DURATION);

      // Belt-and-suspenders: also listen for animationend in case timing drifts
      overlay.addEventListener('animationend', function handler(e) {
        if (e.animationName === 'rg-overlay-up') {
          clearTimeout(doneTimer);
          overlay.removeEventListener('animationend', handler);
          overlay.classList.add('is-done');
          if (typeof onComplete === 'function') onComplete();
        }
      });

    }, reducedMotion ? REDUCED_TOTAL : HOLD_DURATION);

    return holdTimer;
  }

  // ── Page load ────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { runIntro(); });
  } else {
    runIntro();
  }

})();
